import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditComponent } from '../epp/edit/edit.component';
import { AddEppComponent } from './add-epp/add-epp.component';
import { AddNewComponent } from './add-new/add-new.component';
import { EditByIdComponent } from './edit-by-id/edit-by-id.component';
import { EditByUseridComponent } from './edit-by-userid/edit-by-userid.component';
import { MainEppComponent } from './main-epp/main-epp.component';
import { ViewEppComponent } from './view-epp/view-epp.component';
import { ViewbyIdComponent } from './viewby-id/viewby-id.component';

const routes: Routes = [
  {
    path: 'view-epp',
    component: ViewEppComponent,
  },
  {
    path: 'add',
    component: AddEppComponent,
  },
  {
    path: 'add-new',
    component: AddNewComponent,
  },
  {
    path: '',
    component: MainEppComponent,
  },
  {
    path: 'edit/:UserID/:userEPPSubscription',
    component: EditComponent,
  },
  {
    path: 'view/:UserID',
    component: ViewbyIdComponent,
  },
  {
    path: 'EditById/:UserID',
    component: EditByUseridComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EppRoutingModule {}
